import React from 'react';
import { Box, Grid2, Typography } from "@mui/material";
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);


const ProjectStatusOverviewHead = ({ lastModified, marginBottm }) => {

    const formattedDate = lastModified ? dayjs(lastModified).format('Do MMMM YYYY') : dayjs(new Date()).format('Do MMMM YYYY');

    return (
        <Grid2 size={12}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                flexDirection={{ xs: "column", md: "row" }}
                gap={1}
            >
                <Typography
                    sx={{
                        fontSize: '20px',
                        fontWeight: 500,
                        color: '#000',
                        mb: { xs: 0.5, md: 1 },
                        lineHeight: '100%',
                        letterSpacing: '-0.4px',
                        textAlign: { xs: "center", md: "left" },
                        width: { xs: "100%", md: "auto" },
                    }}
                >
                    Status overview of all Projects
                </Typography>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        color: '#858EA0',
                        mb: { xs: 1, md: 1 },
                        lineHeight: '100%',
                        letterSpacing: '-0.4px',
                        textAlign: { xs: "center", md: "right" },
                        width: { xs: "100%", md: "auto" },
                    }}
                >
                    Last Modified on {formattedDate}
                </Typography>
            </Box>

            <Typography
                sx={{
                    fontSize: '18px',
                    fontWeight: 400,
                    color: '#182A4E80',
                    mb: marginBottm,
                    lineHeight: '100%',
                    letterSpacing: '-0.4px',
                    textAlign: { xs: "center", md: "left" },
                }}
            >
                Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
            </Typography>
        </Grid2>
    );
};

export default ProjectStatusOverviewHead;